export { default as adDeactivatedSoldModel } from './model'
